import React, { useState, useRef, useEffect } from 'react';
import { useRegion } from '../../context/RegionContext';
import { MapPin, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getProvinceCatalogPath } from '../../utils/locationNavigation';

const RegionSelector = () => {
  const { selectedProvince, selectProvince, provinces } = useRegion();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const activeProvince = provinces.find(p => p.id === selectedProvince) || provinces[0];

  return (
    <div className="relative inline-block text-left pb-2 -mb-2" ref={dropdownRef} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-left text-sm font-medium text-dark-800 rounded-lg hover:bg-primary-50 transition-colors duration-200"
        aria-label="Choose your shopping area"
      >
        <MapPin className="w-4 h-4 text-primary-600" />
        <span className="flex flex-col leading-tight"><span className="font-semibold">{activeProvince.name}</span><span className="mt-0.5 text-[10px] font-medium text-gray-500">Shop by province</span></span>
        <ChevronDown className="w-3.5 h-3.5 text-gray-500" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full w-56 rounded-lg bg-white shadow-lg border border-gray-100 py-1 z-50 animate-fade-in origin-top-right">
          <div className="px-3 py-1.5 text-xs font-bold text-gray-400 uppercase tracking-wider">
            Choose your shopping area
          </div>
          {provinces.map((prov) => (
            <button
              key={prov.id}
              onClick={() => {
                selectProvince(prov.id);
                setIsOpen(false);
                navigate(getProvinceCatalogPath(prov.id));
              }}
              className={`w-full px-4 py-2 text-left text-sm transition-colors duration-150 hover:bg-primary-50 hover:text-primary-700 ${selectedProvince === prov.id ? 'bg-primary-50 font-semibold text-primary-700' : 'text-dark-700'}`}
            >
              {prov.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RegionSelector;
